import { useState } from "react";
import { getUrlQuerysection } from "../../../../helpers";
import { useGetCustomers } from "../../../../hooks/api/queries";
import { useSelector } from "react-redux";
import { useStoreCurrency } from "../../../../hooks/useStoreCurrency";
import { useUrlSearch } from "../../../../hooks/useUrlSearch";

const useAllCustomers = () => {
  const queries = getUrlQuerysection();
  const {
    search,
    setSearch,
    gotoPage,
    filterBySearch,
    filterByStoreId,
    filterByDate,
    getDatePartValue,
    handleDatePartChange,
  } = useUrlSearch();
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const [isCustomerWidget, setIsCustomerWidget] = useState(false);
  const [isExportWidget, setIsExportWidget] = useState(false);
  const { storeHasMultipleCurrency } = useStoreCurrency();
  const [currentStore, setCurrentStore] = useState(
    storeHasMultipleCurrency ? search.get("store_id") || storeList[0]?.id : "",
  );

  const { isLoading: isFetchingCustomers, data: customers } = useGetCustomers({
    queries,
  });

  const [birthdayMonth, setBirthdayMonth] = useState(
    getDatePartValue("birthday", "month"),
  );

  return {
    isFetchingCustomers,
    customers: customers?.data || [],
    metaDetails: customers?.meta,
    search,
    storeList,
    storeHasMultipleCurrency,
    currentStore,
    isCustomerWidget,
    isExportWidget,
    setSearch,
    gotoPage,
    searchCustomers: filterBySearch,
    filterByStoreId,
    setCurrentStore,
    setIsCustomerWidget,
    setIsExportWidget,
    filterByDate,
    birthdayMonth,
    setBirthdayMonth,
    handleDatePartChange,
  };
};
export default useAllCustomers;
